/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for common mobile log service.
 */
'use strict';

angular
  .module('services.mobile.log', [])
  /**
   * A factory for mobile log utilities.
   */
  .factory('mobileLogFactory', function (httpActivities, $q, LOG_TYPE) {
    // variables used for paging the log feeds.  The audits/activities params
    // objects are used when requesting data from the server.
    var limit = 10,
      sort = 'date',
      ascending = false,
      activitiesParams = {
        limit: limit,
        offset: 0,
        sort: sort,
        ascending: ascending
      },
      auditsParams = {
        limit: limit,
        offset: 0,
        sort: sort,
        ascending: ascending
      };

    return {
      /**
       * Function used to load the first data set for each of the log types.  It only load
       * if no data has previously been loaded or if the refresh param is true.
       *
       * @param {boolean} refresh - True to force a reload of data.
       * @returns {Promise} - A promise that resolves when the first page of both
       * the activities and audits have finished loading, or immediately if no
       * load was required.
       */
      loadInitialActivities: function (refresh) {
        var activitiesPromise, auditsPromise;
        // Only load the initial data is none of already loaded.
        if (this.logData.activities.items.length === 0 || refresh) {
          activitiesParams.offset = 0;
          activitiesPromise = this.loadActivities();

          auditsParams.offset = 0;
          auditsPromise = this.loadAudits();

          return $q.all([activitiesPromise, auditsPromise]);
        } else {
          var deferred = $q.defer();
          deferred.resolve();
          return deferred.promise;
        }
      },

      /**
       * Utility function used to load the next page of activities.
       * @returns {Promise} - A promise that resolves to indicate that the next
       * page of data has been loaded.
       */
      loadActivities: function () {
        var me = this;
        return httpActivities.getActivities(activitiesParams).then(function (activities) {
          angular.forEach(activities.rows, function (activity) {
            me.logData.activities.items.push(activity);
          });
          me.logData.activities.total = activities.count;
          activitiesParams.offset = activities.rows.length + activitiesParams.offset;
        });
      },

      /**
       * Utility function used to load the next page of audit items.
       * @returns {Promise} - A promise that resolves to indicate that the next
       * page of data has been loaded.
       */
      loadAudits: function () {
        var me = this;
        return httpActivities.getAuditEvents(auditsParams).then(function (audits) {
          angular.forEach(audits.rows, function (audit) {
            me.logData.audits.items.push(audit);
          });
          me.logData.audits.total = audits.count;
          auditsParams.offset = audits.rows.length + auditsParams.offset;
        });
      },

      /**
       * Used to refresh the data on the page.  It will clear all loaded data and load
       * the first page of audit and activity data.
       *
       * @returns {Promise} - A promise that resolves after the refresh of data is complete.
       */
      refresh: function () {
        this.logData.activities.total = 0;
        this.logData.activities.items = [];
        this.logData.audits.total = 0;
        this.logData.audits.items = [];
        return this.loadInitialActivities();
      },

      /**
       * Set the current audit item based on it's id.
       *
       * @param {number} id - The id of the audit item to be set as the current
       *  audit item.
       */
      setCurrentAuditItem: function (id) {
        this.viewInfo.currentAuditItem = _.find(this.logData.audits.items, function (auditItem) {
          return auditItem.id === id;
        });
      },

      /**
       * Toggle the logView value.
       */
      changeLog: function () {
        if (this.viewInfo.logView === LOG_TYPE.ACTIVITY) {
          this.viewInfo.logView = LOG_TYPE.AUDIT;
        } else {
          this.viewInfo.logView = LOG_TYPE.ACTIVITY;
        }
      },

      /**
       * logData - Object used to track audit and activity data.  It has two properties:
       * activities and audits.
       *
       * Each of those are keys to an object that has the following properties:
       *
       * total - The total number of items.
       * items - An array that holds the loaded data.
       */
      logData: {
        activities: {
          total: 0,
          items: []
        },
        audits: {
          total: 0,
          items: []
        }
      },
      viewInfo: {
        currentAuditItem: undefined,
        logView: LOG_TYPE.ACTIVITY
      }
    };
  });
